import { render, staticRenderFns } from "./CreateCondominiumTab.vue?vue&type=template&id=19cd5353&scoped=true"
import script from "./CreateCondominiumTab.vue?vue&type=script&lang=js"
export * from "./CreateCondominiumTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd5353",
  null
  
)

export default component.exports